import { bookingJourney } from './booking';

/**
 * Component-only re-export (ADR-019): keeps the booking wiring module a clean
 * Fast-Refresh boundary by isolating the provider component from the hook and
 * schema it lives alongside.
 */
export const BookingJourneyProvider = bookingJourney.JourneyProvider;
